/**
 * Validate an OAuth redirect value from search params.
 * Only allows redirects to the OAuth authorize page (prevent open redirect).
 */
export function getValidOAuthRedirect(value: string | null): string | null {
  if (!value) return null
  if (value.startsWith('/oauth/authorize?')) return value
  return null
}

/**
 * Validate a post-auth redirect path from search params.
 * Only allows internal paths (single leading slash, no protocol-relative `//`).
 */
export function getValidRedirect(value: string | null): string | null {
  if (!value) return null
  if (value.startsWith('/') && !value.startsWith('//')) return value
  return null
}
